export const hasPageUnifiedMenu = (pageData: any): boolean | undefined => {
  return pageData?.blocks?.some(
    (block: { type: string }) => block.type === 'canalplus.block.unified.menu'
  );
};
